// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Autocomplete, InputAdornment, Popper, TextField } from '@mui/material';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const PopperStyle = styled((props) => <Popper placement="bottom-start" {...props} />)({
  width: '280px !important',
});

SpacePostSearchByName.propTypes = {
  placeholder: PropTypes.string,
};

export default function SpacePostSearchByName({ posts, value, handleSearchTerm, placeholder }) {
  return (
    <Autocomplete
      sx={{ width: 300 }}
      autoHighlight
      popupIcon={null}
      PopperComponent={PopperStyle}
      options={posts !== undefined ? posts : []}
      getOptionLabel={(post) => post?.vehicleDetailObj ? post?.vehicleDetailObj?.model : post?.address}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onSelect={(event) => {
        console.log("select event", event)
        handleSearchTerm(event);
      }}
      onBlur={(event) => {
        console.log("event blur", event)
        handleSearchTerm(event)
      }}
      renderInput={(params) => (
        <TextField
        fullWidth
        {...params}
          placeholder={placeholder}
          value={value !== undefined ? value : ''}
          onChange={handleSearchTerm}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon={'eva:search-fill'} sx={{ ml: 1, width: 20, height: 20, color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
